import { create } from 'zustand';

// ============================================================
// G2：区域框选选择（框选 → 区域批量 AI 操作）
// - ids：框选命中的模型 id（AiEditorPanel 以 scope=region + modelIds 提交，服务端硬锁定）
// - openRequest：框选完成后请求打开 AI 面板（自增信号）
// ============================================================
interface RegionSelectState {
  ids: string[];
  openRequest: number;
  setSelection: (ids: string[]) => void;
  requestOpen: () => void;
  clear: () => void;
}

export const useRegionSelectStore = create<RegionSelectState>((set) => ({
  ids: [],
  openRequest: 0,
  setSelection: (ids) => set({ ids }),
  requestOpen: () => set((s) => ({ openRequest: s.openRequest + 1 })),
  clear: () => set({ ids: [] }),
}));
